import { ClientForm, TextInput, FormActions, Button } from "livemap-ui";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useAddToast } from "../contexts/toast";
import { useFocus } from "../hooks/focus";
import { FormProps } from "./FormProps";

export interface VerificationFormData {
  verificationCode: string;
}

export interface VerificationFormProps {
  isSending: boolean;
}

export interface VerificationFormDispatch {
  onSubmit(form: VerificationFormData): void;
}

type Props = VerificationFormDispatch & VerificationFormProps & FormProps;

export function VerificationForm({ isSending, onSubmit, isActive }: Props) {
  const [focusRef, setInputFocus] = useFocus();

  const addToast = useAddToast();
  const { register, handleSubmit, errors } = useForm<VerificationFormData>({
    reValidateMode: "onBlur",
  });
  const [code, setCode] = useState("");

  useEffect(() => {
    if (errors.verificationCode) {
      addToast({
        id: "bad-verification-code",
        title: "Invalid code",
        text: errors.verificationCode.message || "",
        type: "danger",
      });
    }
  }, [addToast, errors.verificationCode]);

  useEffect(() => {
    isActive && setInputFocus();
  }, [isActive, setInputFocus]);

  return (
    <ClientForm onSubmit={handleSubmit(onSubmit)}>
      <TextInput
        label="Code"
        name="verificationCode"
        autoComplete="off"
        value={code}
        onTextChange={(text) => setCode(text.replace(/\W/i, "").toUpperCase())}
        ref={(htmlRef) => {
          focusRef.current = htmlRef;
          register({
            required: "Please enter a verification code",
            minLength: {
              value: 6,
              message: "The verification code should be 6 characters",
            },
          })(htmlRef);
        }}
      />

      <FormActions>
        <Button disabled={isSending}>Verify</Button>
      </FormActions>
    </ClientForm>
  );
}
